import React, { useEffect } from "react";
import "../styles/success.css";

export default function Success() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div className="success-page page-container">
			<img src="/festivalatsi.png" className="festivalaki-hero" />
			<h3 className="event-dates-heading">4 - 6 December 2026</h3>
			<h1>Registration Successful</h1>
			<div className="success-text-wrapper">	
				<p className="success-text">
				You're officially on board for <strong>Festivalatsi Vol. 4</strong>! We can't wait
				to welcome you for a weekend of dancing, learning, and creating unforgettable moments together.
				</p>
				<div className="email-note">
					💌 If you checked the option, a copy of your responses is on its way to your inbox.
				</div>
				<div className="spam-note">
					* If you don't see it, please check your spam or promotions folder.
				</div>
			</div>
			<button className="new-registration">
				<a href="/festivalaki/registration-26">
					NEW REGISTRATION
				</a>
			</button>
		</div>
	);
}

const ctaBtnStyle = {
	textDecoration: "none",
	textAlign: "center",
	padding: "0.75rem 0.9rem",
	borderRadius: 10,
	background: "#eef7fb",
	color: "#0d4d72",
	fontSize: ".8rem",
	fontWeight: 600,
	letterSpacing: ".5px",
	textTransform: "uppercase",
	border: "1px solid #d0e6ef",
	transition: "all .2s ease"
};
